import React from 'react';
import createBodyColumn from './createBodyColumn';

export default function createRow(row, key) {
    return(
        <tr key={key} className={row.classNames}>
            {row.columns.map((column, index) => createBodyColumn(column, index.toString()))}
        </tr>
    );
}


// WEBPACK FOOTER //
// ./src/common/table/createRow.js